import getters from '@/store/modules/notification/getters'
import mutations from '@/store/modules/notification/mutations'
import actions from '@/store/modules/notification/actions'

export default {
  namespaced: true,
  state() {
    return {
      notifications: [],
    }
  },
  getters,
  actions,
  mutations
}
